/**
 * Code Service
 * 공통 코드 관련 API 호출을 담당하는 서비스
 * 4개 메서드 (2개 API + 2개 헬퍼)
 */

import { apiClient } from '@/lib/api-client';
import type { ApiResponse } from '@/lib/types/api';
import type { CodeItem, CodeAttrItem } from '@/types/code';

class CodeService {
  /**
   * 공통 코드 조회
   * GET /common/codes/{upper_code}/{lvl}
   */
  async getCodes(upperCode: string, lvl: number): Promise<ApiResponse<CodeItem[]>> {
    return apiClient.get<CodeItem[]>(`/common/codes/${upperCode}/${lvl}`);
  }

  /**
   * 공통 코드 속성값 조회
   * GET /common/codes/{upper_code}/{lvl}/{attr_code}
   */
  async getCodeAttrValues(
    upperCode: string, 
    lvl: number, 
    attrCode: string
  ): Promise<ApiResponse<CodeAttrItem[]>> {
    return apiClient.get<CodeAttrItem[]>(`/common/codes/${upperCode}/${lvl}/${attrCode}`);
  }

  /**
   * 직무 코드 조회 (헬퍼 메서드)
   * GET /common/codes/JOB/1
   */
  async getJobCodes(): Promise<ApiResponse<CodeItem[]>> {
    return this.getCodes('JOB', 1);
  }

  /**
   * 관심사 코드 조회 (헬퍼 메서드)
   * GET /common/codes/INTEREST/1/EMBEDING_TEXT
   */
  async getInterestCodes(): Promise<ApiResponse<CodeAttrItem[]>> {
    return this.getCodeAttrValues('INTEREST', 1, 'EMBEDING_TEXT');
  }
}

// 싱글톤 인스턴스 export
export const codeService = new CodeService();

